import MuiIconButton from "@mui/material/IconButton";
const IconButton = MuiIconButton;
export default IconButton;
